/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_ForbiddenInputs */

const id_tld_pricing_forbidden = /** @type {(inputs: Tld_Pricing_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya superadmin dan finance yang dapat mengubah harga domain.`)
};

const en_tld_pricing_forbidden = /** @type {(inputs: Tld_Pricing_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only a superadmin or finance can change domain pricing.`)
};

/**
* | output |
* | --- |
* | "Only a superadmin or finance can change domain pricing." |
*
* @param {Tld_Pricing_ForbiddenInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_forbidden = /** @type {((inputs?: Tld_Pricing_ForbiddenInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_ForbiddenInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_forbidden(inputs)
	return id_tld_pricing_forbidden(inputs)
});